(() => {
  const observed = new WeakSet();
  let queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.resource-list__carousel').forEach(rail => {
      if (observed.has(rail)) return;
      const image = rail.querySelector('.card-gallery');
      if (!image) return;
      observed.add(rail);
      const resize = new ResizeObserver(() => {
        if (!rail.isConnected) { resize.disconnect(); return; }
        const rect = image.getBoundingClientRect();
        const container = rail.querySelector('slideshow-container');
        if (!rect.height || !container) return;
        rail.style.setProperty('--loc-carousel-arrow-y', `${rect.top + rect.height / 2 - container.getBoundingClientRect().top}px`);
        rail.dataset.locArrows = '';
      });
      resize.observe(rail); resize.observe(image);
    });
  }
  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  }).observe(document.documentElement, { subtree: true, childList: true });
  scan();
})();
